// İSG uzmanı portalı — Belge Şemaları düzenleme onayı (GL #7 D1/D2, tasarım review §2.4). SAF.
//
// Pasifleştirme ve geçerlilik kuralı değişikliği TÜM firmalarda geriye dönük etkilidir; `PUT`
// onaylanmadan gönderilmez. Karar, yüklü satır ile gönderilecek değerlerin farkından türetilir:
// değişmeyen alan için onay ASLA çıkmaz (QA matrisi {değişmedi, yalnız etiket, kural, pasif, ikisi}).

import type { DocumentExpiryRule } from '@isgportal/shared';

export interface ConfirmDiff {
  /** Aktif bir tür pasifleşiyor. */
  deactivate: boolean;
  /** Geçerlilik kuralı değişiyor. */
  expiryChanged: boolean;
  /** Kural `EndDateRequired`'a geçiyor (ağır yön: tarihsiz mevcut belgeler Eksik olur). */
  toRequired: boolean;
}

export function diffNeedsConfirm(
  row: { isActive: boolean; expiryRule: DocumentExpiryRule },
  next: { isActive: boolean; expiryRule: DocumentExpiryRule },
): ConfirmDiff {
  const expiryChanged = row.expiryRule !== next.expiryRule;
  return {
    deactivate: row.isActive && !next.isActive,
    expiryChanged,
    toRequired: expiryChanged && next.expiryRule === 'EndDateRequired',
  };
}

export function needsConfirm(diff: ConfirmDiff): boolean {
  return diff.deactivate || diff.expiryChanged;
}
